import React, { useContext} from 'react';
import { Switch } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import { LocalizationContext } from '../../../contexts';
import './index.scss';
import '../forms.scss';

export default function PublishSwitch({ isPublish, canPublish, updateItem, ...rest }) {
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  return <div className={`form-field publish-field`}>
    <Label className="form-field__label inline_label">{labels.pagesManagement.forms.publish_title} </Label>
    <Switch checked={isPublish} disabled={!canPublish} onChange={updateItem} />
    <Label className="form-field__label inline_label"> {!canPublish ? labels.pagesManagement.forms.publish_not_ready : isPublish ? labels.pagesManagement.forms.is_publish : labels.pagesManagement.forms.publish_ready}</Label>
  </div>;
};